/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Lazy loading of a component WizardProductOfferings
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "WizardProductOfferings" */ './components/ProductOfferings'), undefined);
